import { NavLink } from 'react-router-dom';
import { useHaptic } from '@/hooks/useHaptic';

interface NavItem {
  to: string;
  label: string;
  icon: string;
}

const ITEMS: readonly NavItem[] = [
  { to: '/alpha', label: 'Alpha', icon: '💰' },
  { to: '/beta',  label: 'Beta',  icon: '🤖' },
  { to: '/gamma', label: 'Gamma', icon: '⚡' },
  { to: '/delta', label: 'Delta', icon: '📈' },
  { to: '/epsilon', label: 'Epsilon', icon: '🎯' },
  { to: '/zeta', label: 'Zeta', icon: '📊' },
  { to: '/eta', label: 'Eta', icon: '⚖️' },
  { to: '/theta', label: 'Theta', icon: 'θ' },
  { to: '/settings', label: 'Настройки', icon: '⚙️' },
];

/** Нижняя навигационная панель в стиле iOS/Telegram. Учитывает safe-area-bottom. */
export function BottomNav(): JSX.Element {
  const { selection } = useHaptic();
  return (
    <nav
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        background: 'var(--tg-section-bg)',
        borderTop: '0.5px solid var(--tg-separator)',
        paddingBottom: 'var(--safe-bottom)',
        zIndex: 100,
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${ITEMS.length}, 1fr)`,
          height: 56,
        }}
      >
        {ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={() => selection()}
            style={({ isActive }) => ({
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              fontSize: 10,
              textDecoration: 'none',
              color: isActive ? 'var(--tg-button)' : 'var(--tg-hint)',
            })}
          >
            <span style={{ fontSize: 20 }}>{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
